import {
  FileText, ClipboardList, PenTool, Landmark, ShieldCheck, BadgeCheck, Palette,
  MonitorSmartphone, BarChart3, Receipt, GraduationCap, Compass, Sparkles, Building2,
} from "lucide-react";
import { SUPPORT_ITEMS } from "./data/content";
import Reveal from "./Reveal";

const ICONS = {
  FileText, ClipboardList, PenTool, Landmark, ShieldCheck, BadgeCheck, Palette,
  MonitorSmartphone, BarChart3, Receipt, GraduationCap, Compass, Sparkles, Building2,
};

export const Support = () => (
  <section id="support" className="border-y border-white/10 bg-surface/50 py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="label-mono">Practical support</p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          We take care of the work that takes you away from clients.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
          Fourteen jobs that would otherwise be your payroll, your evenings or your risk — handled by
          experienced people, included in your membership.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-4">
        {SUPPORT_ITEMS.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={Math.min(i * 0.04, 0.4)} className="h-full">
              <div
                className="group flex h-full items-start gap-4 rounded-xl border border-white/10 bg-panel/50 p-5 transition-all duration-200 hover:-translate-y-1 hover:border-gold/40 hover:bg-panel sm:p-6"
                data-testid={`support-item-${i + 1}`}
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gold/30 bg-gold/10 transition-colors duration-200 group-hover:bg-gold/20">
                  <Icon className="h-4.5 w-4.5 h-[18px] w-[18px] text-gold-light" />
                </span>
                <p className="pt-1.5 text-sm font-medium leading-snug text-slate-200">{item.title}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Support;
